import React from 'react';
import { Container, Card } from 'react-bootstrap';

function SOPAssistant() {
  return (
    <Container className="py-4">
      <h1 className="mb-4">AI SOP Assistant</h1>
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title>Standard Operating Procedures Made Easy</Card.Title>
          <Card.Text className="text-muted">
            Create, manage, and optimize your business processes with AI assistance.
          </Card.Text>
          <hr />
          <p className="text-muted mb-0">
            <em>Coming soon: SOP generator, process documentation, and workflow automation.</em>
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default SOPAssistant;
